import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { makeStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Paper from "@material-ui/core/Paper";
import { fontSize } from "@mui/system";
import Checkbox from "@mui/material/Checkbox";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

import Loader from "../../../components/Loader/Loader";
import { cubejsApi } from "../../Cubejs/CubejsApiWrapper";
import { useCubeQuery } from "@cubejs-client/react";
import ArrowLeftIcon from "@mui/icons-material/ArrowLeft";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import Mqqtdata from "../../ProcessDashboard/Mqqtdata";
import { images } from "../../../config";
import { useDispatch, useSelector } from "react-redux";
import { ToastContainer, toast } from "react-toastify";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import {
  CompactTagUnit,
  CompactTagValue,
} from "../../../components/CompactValue/CompactValue";
import { setProcessDashboarDateSet } from "../../ProcessDashboard/sliceProcessDashboard/dateSliceprocessDashboard";
import { SoftTagFormula } from "../../SmartTag/softTag/SoftTagFormula";
import { timeStampCheckStatus } from "../../../components/TimeStampCheckStatus/timeStampCheckStatus";
import { getOverViewConfuguration } from "../../ProcessDashboard/OverView/services";
import Switch from "@mui/material/Switch";
import { updateOverviewPositionData } from "../../ProcessDashboard/OverView/services";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    borderCollapse: "separate",
    borderSpacing: 0,
  },
  stickyHeader: {
    position: "sticky",
    top: 0,
    zIndex: 99,
    backgroundColor: "#fff",
    fontSize: 16,
    fontWeight: 500,
  },
  tableWrapper: {
    maxHeight: 688,
    overflowY: "auto",
  },
});

const BPCLInveters = () => {
  const [overViewTagData, setOverViewTagData] = useState([]);
  const [overViewDeviceData, setOverViewDeviceData] = useState([]);
  const [overViewDeviceTagData, setOverViewDeviceTagData] = useState([]);
  const [tableRowData, setTableRowData] = useState([]);
  const [deviceId, setDeviceId] = useState([]);
  const [unitId, setUnitId] = useState([]);
  const [deviceIndex, setDeviceIndex] = useState([]);
  const [unitIndex, setUnitIndex] = useState([]);
  const [topics, setTopics] = useState([]);
  const [mqttTagData, setMqttTagData] = useState([]);
  const [tagData, setTagData] = useState([]);
  const [openDeviceId, setOpenDeviceId] = useState(null);
  const [isNotified, setIsNotified] = useState(false);
  const [MqttTime, setMqttTime] = useState("");
  const [formatedchecked, setFormatedchecked] = useState(false);
  const [overview_id, setOverview_id] = useState("");
  const [positionData, setPositionData] = useState(null);
  const [API_position_data, setAPI_Position_data] = useState({});

  // Toggle function to open/close specific device
  const toggleDevice = (deviceId) => {
    setOpenDeviceId(openDeviceId === deviceId ? null : deviceId);
  };

  const { user_access } = useSelector((state) => state.userState);

  const { selectUnit } = useSelector(
    (state) => state.dateSliceprocessDashboardState
  );

  const navigate = useNavigate();
  const classes = useStyles();
  const tableRef = useRef(null);

  const param = useParams();

  const notifyError = (message) =>
    toast.error(message, {
      theme: "colored",
      position: toast.POSITION.TOP_RIGHT,
      toastClassName: "custom-toast",
    });

  const handleScroll = (event) => {
    const target = event.target;
    const scrollTop = target.scrollTop;
    const scrollHeight = target.scrollHeight;
    const clientHeight = target.clientHeight;

    // Check if the user scrolled to the top of the table
    if (scrollTop === 0) {
      // Page up logic goes here
    }

    // Check if the user scrolled to the bottom of the table
    if (scrollHeight - scrollTop === clientHeight) {
      // Page down logic goes here
    }
  };
  const convertTimeStampFormat = mqttTagData
    ? Object.keys(mqttTagData).map((row) => {
        const findTimeStamp = mqttTagData[row].find(
          (f) => f.device_tag == "TIMESTAMP"
        );
        return {
          ...findTimeStamp,
          TIMESTAMP: findTimeStamp?.TIMESTAMP || "",
        };
      })
    : [];

  useEffect(() => {
    const getData = timeStampCheckStatus(convertTimeStampFormat);

    if (!isNotified && Array.isArray(getData) && getData.length > 0) {
      const { device_tag, tagDateAndTimeFormat, tagValue } = getData[0];
      setMqttTime(tagValue);
      const notifyError = (message) =>
        toast.error(message, {
          theme: "colored",
          position: toast.POSITION.TOP_RIGHT,
          toastClassName: "custom-toast",
        });

      if (device_tag && tagDateAndTimeFormat && tagValue) {
        notifyError(
          <div>
            <p>Device Tag: {device_tag}</p>
            <p>Current Time: {tagDateAndTimeFormat}</p>
            <p>Mqtt Time: {tagValue}</p>
          </div>
        );
        setIsNotified(true);
      }
    }
  }, [mqttTagData, isNotified]);

  useEffect(() => {
    GetOverviewConfigurationApi();
  }, []);

  const [isStructured, setIsStructured] = useState(true);

  const GetOverviewConfigurationApi = async () => {
    const paramRequset = {
      plant_id: param.id,
      company_id: param.companyId,
    };
    const resp = await getOverViewConfuguration(paramRequset);
    if (resp.status == 200) {
      if (resp.data.payload.length) {
        setOverview_id(resp.data.payload[0].id);
        setAPI_Position_data(resp.data.payload[0].position_data);
        const switchData = resp.data.payload[0]?.is_store;
        setFormatedchecked(switchData);
        const uniqueTagUnits = {};
        const filteredTags = resp.data.payload[0].tag_assigned.filter((tag) => {
          if (!uniqueTagUnits[tag.tag_unit]) {
            uniqueTagUnits[tag.tag_unit] = true;
            return true;
          }
          return false;
        });
        setOverViewTagData(filteredTags);
        setOverViewDeviceData(resp.data.payload[0].device);
        setOverViewDeviceTagData(resp.data.payload[0].tag_assigned);
      }
    }
  };

  // topic array

  useEffect(() => {
    if (overViewDeviceData.length) {
      const topicArray = overViewDeviceData.map(
        (e) => "Hikar/DeviceUID/" + e.machine_uid
      );
      // console.log("topicArray", topicArray);
      setTopics(topicArray);
    }
  }, [overViewDeviceData]);

  const handleSelectDevice = (id, index) => {
    if (!Array.isArray(deviceId)) {
      setDeviceId([]);
    }
    if (deviceId.includes(id) || deviceIndex.includes(index)) {
      setDeviceId(deviceId.filter((element) => element !== id));
    } else {
      setDeviceId([id]);
    }

    if (!Array.isArray(deviceIndex)) {
      setDeviceIndex([]);
    }
    if (deviceIndex.includes(index)) {
      setDeviceIndex(deviceIndex.filter((element) => element !== index));
    } else {
      setDeviceIndex([index]);
    }
  };

  const handleSelectUnit = (id, index) => {
    if (!Array.isArray(unitId)) {
      setUnitId([]);
    }
    if (unitId.includes(id) || deviceIndex.includes(index)) {
      setUnitId(unitId.filter((element) => element !== id));
    } else {
      setUnitId([id]);
    }

    if (!Array.isArray(unitIndex)) {
      setUnitIndex([]);
    }
    if (unitIndex.includes(index)) {
      setUnitIndex(unitIndex.filter((element) => element !== index));
    } else {
      setUnitIndex([index]);
    }
  };
  const handlePositionChange = (
    deviceData = overViewDeviceData,
    tagData = overViewTagData
  ) => {
    const overview_config_id = overview_id;

    const unit_positions = {};
    tagData.forEach((unit, idx) => {
      unit_positions[idx + 1] = unit.tag_unit || unit.name;
    });

    const device_positions = {};
    deviceData.forEach((device, idx) => {
      device_positions[idx + 1] = device.id;
    });

    const position_data = {
      is_store: formatedchecked,
      overview_config_id,
      unit_positions,
      device_positions,
    };

    updateOverviewPositionData(position_data); // send as object
  };
// useEffect(()=>{
//   if(formatedchecked == true){
//     const unit_positions = {};
//       overViewTagData.forEach((unit, idx) => {
//         unit_positions[idx + 1] = unit.tag_unit || unit.name;
//       });

//       const device_positions = {};
//       overViewDeviceData.forEach((device, idx) => {
//         device_positions[idx + 1] = device.id;
//       });

//       const position_data = {
//         is_store: formatedchecked,
//         overview_config_id: overview_id,
//         unit_positions,
//         device_positions,
//       };

//       console.log("SENDING DATA:", position_data);
//       updateOverviewPositionData(position_data);
//     }
  
// },[formatedchecked])
  // useEffect(() => {
  //   if (
  //     formatedchecked !== null &&
  //     overViewDeviceData?.length &&
  //     overViewTagData?.length &&
  //     overview_id
  //   ) {
  //     const unit_positions = {};
  //     overViewTagData.forEach((unit, idx) => {
  //       unit_positions[idx + 1] = unit.tag_unit || unit.name;
  //     });

  //     const device_positions = {};
  //     overViewDeviceData.forEach((device, idx) => {
  //       device_positions[idx + 1] = device.id;
  //     });

  //     const position_data = {
  //       is_store: formatedchecked,
  //       overview_config_id: overview_id,
  //       unit_positions,
  //       device_positions,
  //     };

  //     console.log("SENDING DATA:", position_data);
  //     updateOverviewPositionData(position_data);
  //   }
  // }, [
  //   formatedchecked,
  //   overViewDeviceData?.length,
  //   overViewTagData?.length,
  //   overview_id,
  // ]);

  function handleDeviceUpMoveRaw(id) {
    const itemIndex = overViewDeviceData.findIndex((item) => item.id === id);

    if (!deviceIndex.length || deviceIndex[0] === -1 || itemIndex === -1)
      return;

    const newDeviceData = [...overViewDeviceData];
    const item = newDeviceData.splice(itemIndex, 1)[0]; // Remove item
    newDeviceData.splice(deviceIndex[0], 0, item); // Re-insert at new index

    setOverViewDeviceData(newDeviceData);
    setDeviceIndex([deviceIndex[0] - 1]);

    if (formatedchecked) {
      handlePositionChange(newDeviceData, overViewTagData); // pass updated data
    }
  }

  function handleDeviceDownMoveRaw(id) {
    const itemIndex = overViewDeviceData.findIndex((item) => item.id === id);

    if (
      !deviceIndex.length ||
      deviceIndex[0] === overViewDeviceData.length - 1 ||
      itemIndex === -1
    )
      return;

    const newDeviceData = [...overViewDeviceData];
    const item = newDeviceData.splice(itemIndex, 1)[0];

    const targetIndex = deviceIndex[0] === 0 ? 1 : deviceIndex[0] + 1;
    newDeviceData.splice(targetIndex, 0, item);

    setOverViewDeviceData(newDeviceData);
    setDeviceIndex([deviceIndex[0] + 1]);

    if (formatedchecked) {
      handlePositionChange(newDeviceData, overViewTagData); // Pass latest device data
    }
  }

  function handleUnitLeftMoveRaw(id) {
    const itemIndex = overViewTagData.findIndex((item) => item.id === id);

    if (!unitIndex.length || unitIndex[0] === -1 || itemIndex === -1) return;

    const newTagData = [...overViewTagData];
    const item = newTagData.splice(itemIndex, 1)[0]; // Remove item
    newTagData.splice(unitIndex[0], 0, item); // Insert at new position

    setOverViewTagData(newTagData);
    setUnitIndex([unitIndex[0] - 1]);

    if (formatedchecked) {
      handlePositionChange(overViewDeviceData, newTagData); // Pass latest tag data
    }
  }

  function handleUnitRightMoveRaw(id) {
    const itemIndex = overViewTagData.findIndex((item) => item.id === id);

    if (
      !unitIndex.length ||
      unitIndex[0] === overViewTagData.length - 1 ||
      itemIndex === -1
    )
      return;

    const newTagData = [...overViewTagData];
    const item = newTagData.splice(itemIndex, 1)[0];

    const targetIndex = unitIndex[0] === 0 ? 1 : unitIndex[0] + 1;
    newTagData.splice(targetIndex, 0, item);

    setOverViewTagData(newTagData);
    setUnitIndex([unitIndex[0] + 1]);

    if (formatedchecked) {
      handlePositionChange(overViewDeviceData, newTagData); // Pass latest tag data
    }
  }
  useEffect(() => {
    if (overViewDeviceTagData.length) {
      const mergedArray = mqttTagData
        ? [].concat(...Object.values(mqttTagData))
        : [];
      const filteredArray = mergedArray.filter((obj) => {
        const device = obj.device__uid;
        const deviceTag = obj.device_tag;
        return overViewDeviceTagData.some(
          (item) => item.device_tag === deviceTag
        );
      });

      setTagData(filteredArray);
    }
  }, [mqttTagData]);

  const uidTag = [
    [{ tag_name: "F1MTR_KVARH" }, { tag_name: "F1MTR_KVAR" }],
    [{ tag_name: "F2MTR_KVAR" }],
  ];
  const plantDashboardAccess = user_access.length
    ? user_access.find(
        (user) => user.access_module?.access_module_name === "Plant Dashboard"
      )
    : null;

  const overViewAccess = plantDashboardAccess
    ? plantDashboardAccess.sub_module.length
      ? plantDashboardAccess.sub_module.find(
          (f) => f.sub_module_name === "Overview"
        )
      : null
    : null;

  const handleTostMsg = () => {
    notifyError("You don't have access");
  };

  const dispatch = useDispatch();

  const handleConfOverViewNavigate = () => {
    navigate(
      `/overview-configration/company/${param.companyId}/plant/${param.id}`
    );
  };
  const mergedArray = [].concat(...Object.values(mqttTagData));
  const mqttDataReduce = mergedArray.reduce((map, item) => {
    map[item.device_tag] = Number(item.tagValue);
    return map;
  }, {});

  const handleFormateChange = (event) => {
    const newCheckedState = event.target.checked;
    setFormatedchecked(newCheckedState);

    // Call handlePositionChange with the updated state for is_store
    // We need to ensure overViewTagData, overViewDeviceData, and overview_id are available
    if (overview_id && overViewTagData.length && overViewDeviceData.length) {
      const unit_positions = {};
      overViewTagData.forEach((unit, idx) => {
        unit_positions[idx + 1] = unit.tag_unit || unit.name;
      });

      const device_positions = {};
      overViewDeviceData.forEach((device, idx) => {
        device_positions[idx + 1] = device.id;
      });

      const position_data = {
        is_store: newCheckedState, // Use the new checked state
        overview_config_id: overview_id,
        unit_positions,
        device_positions,
      };

      updateOverviewPositionData(position_data);
    }
  };
  // console.log(API_position_data.device_positions,"overViewDeviceData")
  const applyPositionOrdering = () => {
    // Format and set unit order
    if (
      Array.isArray(overViewTagData) &&
      overViewTagData.length &&
      API_position_data?.unit_positions
    ) {
      const unitOrder = Object.values(API_position_data.unit_positions);

      const sortedUnits = unitOrder
        .map((unit) => overViewTagData.find((item) => item.tag_unit === unit))
        .filter(Boolean);

      setOverViewTagData(sortedUnits);
    }

    // Format and set device order
    if (
      Array.isArray(overViewDeviceData) &&
      overViewDeviceData.length &&
      API_position_data?.device_positions
    ) {
      const deviceOrder = Object.values(API_position_data.device_positions);

      const sortedDevices = deviceOrder
        .map((id) => overViewDeviceData.find((item) => item.id === id))
        .filter(Boolean);

      setOverViewDeviceData(sortedDevices);

      console.log("→ formatted overViewDeviceData:", sortedDevices);
      console.log(
        "→ used device_positions:",
        API_position_data.device_positions
      );
    }
  };

  useEffect(() => {
    applyPositionOrdering();
  }, [overViewTagData.length, overViewDeviceData.length, API_position_data]);

  return (
    <>
      {overViewDeviceTagData.length ? (
        <Mqqtdata
          setMqttTagData={setMqttTagData}
          topics={topics}
          overViewTagData={overViewDeviceTagData}
        />
      ) : (
        ""
      )}
      <div className="page-wraper pb-5 page-wraper-overview">
        <div className="page-header d-flex justify-content-between overview-table-header">
          <div
            onClick={() =>
              navigate(
                `/bpcl-processdashboard/company/${param.companyId}/plant/${param.id}`
              )
            }
            className="page-back-btn"
          >
            <ArrowBackIcon />
            <span>Inverters</span>
          </div>
          <Switch
            value={formatedchecked}
            checked={formatedchecked}
            onChange={handleFormateChange}
            inputProps={{ "aria-label": "" }}
          />
        </div>
        <div className="overview-card-header">
          <div className="page-header d-flex justify-content-between">
            <div
              className="d-flex justify-content-between"
              style={{ width: "100%", flexWrap: "wrap" }}
            >
              <div
                onClick={() =>
                  navigate(
                    `/company/${param.companyId}/plant/plantprocessdashboard/${param.id}`
                  )
                }
                className="over-view-header"
                style={{ marginTop: "-19px" }}
              >
                <ArrowBackIcon />
                <span>Inverters</span>
              </div>
              <div className="d-flex gap-2">
                <div>
                  <select
                    className="compact-btn"
                    value={selectUnit}
                    onChange={(e) =>
                      dispatch(
                        setProcessDashboarDateSet({
                          selectUnit: e.target.value,
                        })
                      )
                    }
                  >
                    <option value="k">Kilo</option>
                    <option value="m">Mega</option>
                    <option value="g">Giga</option>
                  </select>
                </div>
                <div>
                  {(overViewAccess?.is_viewer && overViewAccess?.is_editor) ||
                  (!overViewAccess?.is_viewer && overViewAccess?.is_editor) ||
                  (overViewAccess?.is_viewer && !overViewAccess?.is_editor) ? (
                    <button
                      className="configration-btn confi-btn"
                      onClick={() => handleConfOverViewNavigate()}
                    >
                      <img
                        src={images.configration}
                        style={{
                          height: "18px",
                          width: "18px",
                          marginRight: "8px",
                        }}
                        alt=""
                      />
                      Configuration
                    </button>
                  ) : (
                    <button
                      className="configration-btn"
                      onClick={handleTostMsg}
                    >
                      <img
                        src={images.configration}
                        style={{
                          height: "18px",
                          width: "18px",
                          marginRight: "8px",
                        }}
                        alt=""
                      />
                      Configuration
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="mb-3">
            {(overViewAccess?.is_viewer && overViewAccess?.is_editor) ||
            (!overViewAccess?.is_viewer && overViewAccess?.is_editor) ||
            (overViewAccess?.is_viewer && !overViewAccess?.is_editor) ? (
              <button
                className="overviewReport"
                style={{ float: "right", marginTop: "-9px" }}
                onClick={() =>
                  navigate(
                    `/overView-analytics/company/${param.companyId}/plant/${param.id}`
                  )
                }
              >
                Report & Analysis
              </button>
            ) : (
              <button
                className="overviewReport "
                style={{ float: "right" }}
                onClick={() => handleTostMsg()}
              >
                Report & Analysis
              </button>
            )}
          </div>
        </div>

        <div className="overviewtable-wrap">
          <div className={`${classes.tableWrapper} overViewTableData`}>
            <TableContainer component={Paper} className="table-overview-data">
              <Table className="overView-data-table" aria-label="my table">
                <TableHead>
                  <TableRow className={classes.stickyHeader}>
                    <TableCell
                      colSpan={2}
                      style={{
                        background: "#ffff",
                        position: "sticky",
                        left: 0,
                        zIndex: 99,
                      }}
                    >
                      {/* <TableCell colSpan={2} style={{ background: "#ffff"}}> */}
                      <div className="d-flex">
                        <div>
                          <div
                            onClick={() => handleDeviceUpMoveRaw(deviceId[0])}
                            style={{ cursor: "pointer" }}
                          >
                            <img src={images.up} alt="" />
                          </div>
                          <div
                            onClick={() => handleDeviceDownMoveRaw(deviceId[0])}
                            style={{ cursor: "pointer" }}
                          >
                            <img src={images.down} alt="" />
                          </div>
                        </div>
                        <div
                          style={{
                            marginTop: "10px",
                            marginLeft: "16px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleUnitLeftMoveRaw(unitId[0])}
                        >
                          <img src={images.left} alt="" />
                        </div>
                        <div
                          style={{ marginTop: "10px", cursor: "pointer" }}
                          onClick={() => handleUnitRightMoveRaw(unitId[0])}
                        >
                          <img src={images.right1} alt="" />
                        </div>
                      </div>
                    </TableCell>
                    {overViewTagData.length
                      ? overViewTagData.map((row, index) => {
                          // Check if the current name has already been included
                          const isDuplicate = overViewTagData
                            .slice(0, index)
                            .some(
                              (prevRow) => prevRow.tag_unit === row.tag_unit
                            );

                          if (!isDuplicate) {
                            return (
                              <TableCell
                                style={{
                                  fontWeight: "700",
                                  fontSize: "17px",
                                  background: "#FFFF",
                                }}
                                key={row.tag_unit}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <Checkbox
                                    checked={unitId.includes(row.id)}
                                    onClick={() =>
                                      handleSelectUnit(row.id, index)
                                    }
                                  />
                                  <span style={{ marginLeft: "5px" }}>
                                    {CompactTagUnit(selectUnit, row.tag_unit)}
                                  </span>
                                </div>
                              </TableCell>
                            );
                          }

                          return null;
                        })
                      : null}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {overViewDeviceData.length
                    ? overViewDeviceData.map((row, ind) => {
                        return (
                          <TableRow>
                            <TableCell style={{ width: "0%" }}>
                              <Checkbox
                                checked={deviceId.includes(row.id)}
                                onClick={() => handleSelectDevice(row.id, ind)}
                              />
                            </TableCell>
                            <TableCell
                              style={{ width: "auto", whiteSpace: "nowrap" }}
                            >
                              {row.device_name}
                            </TableCell>
                            {overViewTagData.length
                              ? overViewTagData.map((row2, index) => {
                                  let findTagUnitValue1 = null;
                                  const deviceNameParts = row.device_name;
                                  if (deviceNameParts) {
                                    const targetTag =
                                      overViewDeviceTagData.find((t) => {
                                        const tagNameParts = t.device_tag;
                                        return (
                                          (tagNameParts || true) && // allow if no match
                                          t.tag_unit === row2.tag_unit &&
                                          row.device_tags?.includes(
                                            t.device_tag
                                          )
                                        );

                                        return false;
                                      });

                                    if (targetTag) {
                                      findTagUnitValue1 = tagData.find(
                                        (f) =>
                                          f.device_tag === targetTag.device_tag
                                      );
                                    }
                                  }

                                  const isDuplicate = overViewTagData
                                    .slice(0, index)
                                    .some(
                                      (prevRow) =>
                                        prevRow.tag_unit === row2.tag_unit
                                    );

                                  if (!isDuplicate) {
                                    return (
                                      // In BPCLInveters.js, within the TableBody mapping for overViewDeviceData and overViewTagData
                                      <TableCell>
                                        {/* Existing logic for soft tags, but it also needs to be device-specific */}
                                        {(() => {
                                          // Filter `overViewDeviceTagData` to find tags relevant to the current device (`row`)
                                          const deviceSpecificTags =
                                            overViewDeviceTagData.filter((t) =>
                                              row.device_tags?.includes(
                                                t.device_tag
                                              )
                                            );

                                          // Find the specific tag that matches the current unit (row2.tag_unit)
                                          const targetTagForDevice =
                                            deviceSpecificTags.find(
                                              (t) =>
                                                t.tag_unit === row2.tag_unit
                                            );

                                          let displayValue = null;

                                          if (
                                            row2?.is_soft_tag &&
                                            row2?.soft_tag_formula &&
                                            Object.keys(mqttDataReduce).length
                                          ) {
                                            // For soft tags, you need a device-specific mqttDataReduce
                                            // Filter mergedArray to include only tags relevant to the current device
                                            const deviceMqttDataReduce =
                                              mergedArray
                                                .filter((item) =>
                                                  row.device_tags?.includes(
                                                    item.device_tag
                                                  )
                                                )
                                                .reduce((map, item) => {
                                                  map[item.device_tag] = Number(
                                                    item.tagValue
                                                  );
                                                  return map;
                                                }, {});

                                            if (
                                              Object.keys(deviceMqttDataReduce)
                                                .length
                                            ) {
                                              const softTagResult =
                                                SoftTagFormula(
                                                  row2?.soft_tag_formula,
                                                  deviceMqttDataReduce
                                                );
                                              if (
                                                softTagResult?.softTagNotGetTag ===
                                                true
                                              ) {
                                                displayValue =
                                                  softTagResult?.value;
                                              } else {
                                                displayValue = ""; // Or empty string, depending on desired behavior
                                              }
                                            }
                                          } else if (targetTagForDevice) {
                                            // Now, find the actual MQTT data for this device-specific tag
                                            const foundMqttTagValue =
                                              tagData.find(
                                                (f) =>
                                                  f.device_tag ===
                                                  targetTagForDevice.device_tag
                                              );

                                            if (foundMqttTagValue) {
                                              displayValue =
                                                foundMqttTagValue.tagUnit
                                                  ?.toLowerCase()
                                                  ?.startsWith("k")
                                                  ? CompactTagValue(
                                                      selectUnit,
                                                      foundMqttTagValue.tagValue
                                                    )
                                                  : foundMqttTagValue.tagValue;
                                            }
                                          }
                                          return displayValue;
                                        })()}
                                      </TableCell>
                                    );
                                  }

                                  return null;
                                })
                              : null}
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        {/* <div>
        <FooterText/>
        </div> */}
      </div>

      {/* =============== Overview - responsive design =============== */}

      <Container maxWidth="xl" className="mb-5">
        <Grid container spacing={2} className="alarm-container">
          {overViewDeviceData.length
            ? overViewDeviceData.map((row) => {
                const isOpen = openDeviceId === row.id; // Check if the current device is open
                return (
                  <Grid item xs={12} sm={6} key={row.id}>
                    <div className="overview-details">
                      <div>{row.device_name}</div> {/* Dynamic device name */}
                      {overViewTagData.slice(0, 3).map((row2, index) => {
                        const itemLabel = CompactTagUnit(
                          selectUnit,
                          row2.tag_unit
                        );
                        let itemValue = null;
                        const deviceNameParts = row.device_name.match(/(\d+)$/);
                        if (deviceNameParts) {
                          const deviceNum = parseInt(deviceNameParts[1], 10);
                          const targetTag = overViewDeviceTagData.find((t) => {
                            const tagNameParts =
                              t.tag_name.match(/^(\D+)(\d+)_/);
                            if (tagNameParts) {
                              const tagNum = parseInt(tagNameParts[2], 10);
                              return (
                                tagNum === deviceNum &&
                                t.tag_unit === row2.tag_unit
                              );
                            }
                            return false;
                          });

                          if (targetTag) {
                            itemValue = tagData.find(
                              (f) => f.device_tag === targetTag.device_tag
                            );
                          }
                        }

                        return (
                          <div key={index} className="overview-details-wrap">
                            <div>
                              <h4>{itemLabel} :</h4>
                            </div>
                            <div>
                              <h6>
                                {row2?.is_soft_tag &&
                                row2?.soft_tag_formula &&
                                Object.keys(mqttDataReduce).length
                                  ? SoftTagFormula(
                                      row2?.soft_tag_formula,
                                      mqttDataReduce
                                    )?.softTagNotGetTag == true
                                    ? SoftTagFormula(
                                        row2?.soft_tag_formula,
                                        mqttDataReduce
                                      )?.value
                                    : 0
                                  : itemValue?.tagUnit
                                      ?.toLowerCase()
                                      ?.startsWith("k")
                                  ? CompactTagValue(
                                      selectUnit,
                                      itemValue?.tagValue
                                    )
                                  : itemValue?.tagValue}
                                {/* {itemValue
                                  ? CompactTagValue(
                                      selectUnit,
                                      itemValue.tagValue
                                    )
                                  : ""} */}
                              </h6>
                            </div>
                          </div>
                        );
                      })}
                      {isOpen &&
                        overViewTagData.slice(3).map((row2, index) => {
                          const itemLabel = CompactTagUnit(
                            selectUnit,
                            row2.tag_unit
                          );
                          let itemValue = null;
                          const deviceNameParts =
                            row.device_name.match(/(\d+)$/);
                          if (deviceNameParts) {
                            const deviceNum = parseInt(deviceNameParts[1], 10);
                            const targetTag = overViewDeviceTagData.find(
                              (t) => {
                                const tagNameParts =
                                  t.tag_name.match(/^(\D+)(\d+)_/);
                                if (tagNameParts) {
                                  const tagNum = parseInt(tagNameParts[2], 10);
                                  return (
                                    tagNum === deviceNum &&
                                    t.tag_unit === row2.tag_unit
                                  );
                                }
                                return false;
                              }
                            );

                            if (targetTag) {
                              itemValue = tagData.find(
                                (f) => f.device_tag === targetTag.device_tag
                              );
                            }
                          }

                          return (
                            <div
                              key={index + 3}
                              className="overview-details-wrap"
                            >
                              <div>
                                <h4>{itemLabel} :</h4>
                              </div>
                              <div>
                                <h6>
                                  {row2?.is_soft_tag &&
                                  row2?.soft_tag_formula &&
                                  Object.keys(mqttDataReduce).length
                                    ? SoftTagFormula(
                                        row2?.soft_tag_formula,
                                        mqttDataReduce
                                      )?.softTagNotGetTag == true
                                      ? SoftTagFormula(
                                          row2?.soft_tag_formula,
                                          mqttDataReduce
                                        )?.value
                                      : 0
                                    : itemValue
                                    ? CompactTagValue(
                                        selectUnit,
                                        itemValue.tagValue
                                      )
                                    : ""}
                                  {/* {itemValue
                                    ? CompactTagValue(
                                        selectUnit,
                                        itemValue.tagValue
                                      )
                                    : ""} */}
                                </h6>
                              </div>
                            </div>
                          );
                        })}
                      <img
                        src={isOpen ? images.upIcon : images.downIcon}
                        alt="toggle visibility"
                        className={isOpen ? "up-arrow" : "down-arrow"}
                        onClick={() => toggleDevice(row.id)} // Pass the device id to toggle function
                      />
                    </div>
                  </Grid>
                );
              })
            : null}
        </Grid>
      </Container>
    </>
  );
};
export default BPCLInveters;
